import { neighborhoodCrudConfig } from '@/config/objects/neighborhoods';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Neighborhoods list page
 */
export function NeighborhoodsPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Neighborhoods', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView config={neighborhoodCrudConfig} baseUrl="/neighborhoods" breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
